var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.5 14.9167C37.375 14.8959 37.2292 14.8959 37.1042 14.9167C34.2292 14.8125 31.9375 12.4584 31.9375 9.54169C31.9375 6.56252 34.3333 4.16669 37.3125 4.16669C40.2917 4.16669 42.6875 6.58336 42.6875 9.54169C42.6667 12.4584 40.375 14.8125 37.5 14.9167Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M35.3543 30.0834C38.2084 30.5626 41.3543 30.0625 43.5626 28.5834C46.5001 26.625 46.5001 23.4167 43.5626 21.4584C41.3334 19.9792 38.1459 19.4792 35.2917 19.9792",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.4375 14.9167C12.5625 14.8959 12.7083 14.8959 12.8333 14.9167C15.7083 14.8125 18 12.4584 18 9.54169C18 6.56252 15.6042 4.16669 12.625 4.16669C9.64584 4.16669 7.25 6.58336 7.25 9.54169C7.27083 12.4584 9.5625 14.8125 12.4375 14.9167Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5833 30.0834C11.7292 30.5626 8.58333 30.0625 6.375 28.5834C3.4375 26.625 3.4375 23.4167 6.375 21.4584C8.60417 19.9792 11.7917 19.4792 14.6458 19.9792",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25 30.4792C24.875 30.4584 24.7292 30.4584 24.6042 30.4792C21.7292 30.375 19.4375 28.0209 19.4375 25.1042C19.4375 22.125 21.8333 19.7292 24.8125 19.7292C27.7917 19.7292 30.1875 22.1459 30.1875 25.1042C30.1667 28.0209 27.875 30.3959 25 30.4792Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.9375 37.0417C16 39 16 42.2084 18.9375 44.1667C22.2708 46.3959 27.7292 46.3959 31.0625 44.1667C34 42.2084 34 39 31.0625 37.0417C27.75 34.8334 22.2708 34.8334 18.9375 37.0417Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamIcon);
export default __webpack_public_path__ + "static/media/team-icon.7eeaea15ab650c19c190cf6b45fd02ba.svg";
export { ForwardRef as ReactComponent };